import { render } from "./hover_dropzone.vue?vue&type=template&id=c7bac69e"
import script from "./hover_dropzone.vue?vue&type=script&lang=js"
export * from "./hover_dropzone.vue?vue&type=script&lang=js"

import exportComponent from "/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/hover_dropzone.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c7bac69e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c7bac69e', __exports__)) {
    api.reload('c7bac69e', __exports__)
  }
  
  module.hot.accept("./hover_dropzone.vue?vue&type=template&id=c7bac69e", () => {
    api.rerender('c7bac69e', render)
  })

}


export default __exports__